import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { ClipboardIcon, CheckIcon } from '@heroicons/react/24/outline';

interface CodeBlockProps {
  language: string;
  children: string;
}

export default function CodeBlock({ language, children }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(children);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative group my-4">
      {/* Header with language label and copy button */}
      <div className="absolute top-0 right-0 left-0 flex items-center justify-between px-3 py-1.5 bg-surface-700/90 rounded-t-lg z-10">
        {/* Language label */}
        <span className="text-xs text-surface-400">
          {language}
        </span>

        {/* Copy button */}
        <button
          onClick={handleCopy}
          className="p-1 rounded hover:bg-surface-600 text-surface-400 hover:text-surface-200 transition-colors"
          title="Copy code"
        >
          {copied ? (
            <CheckIcon className="w-4 h-4 text-green-400" />
          ) : (
            <ClipboardIcon className="w-4 h-4" />
          )}
        </button>
      </div>

      {/* Syntax highlighted code */}
      <SyntaxHighlighter
        style={oneDark}
        language={language}
        PreTag="div"
        customStyle={{
          margin: 0,
          borderRadius: '0.5rem',
          paddingTop: '2.5rem', // Space for the header
        }}
      >
        {children}
      </SyntaxHighlighter>
    </div>
  );
}
